import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // 実際のエンドポイントに変更する

const config = {
  timeout: 30000,
  method: null,
  url: '',
  data: null,
  withCredentials: true,
};

export default {
  // getTaskCards: (authUserId, sessionKey, tableId) => {
  //   config.url = baseUrl + '/api/boardView/search';
  //   config.method = 'POST';
  //   config.data = { authUserId, sessionKey, tableId };

  //   return axios.request(config)
  //     .then((res) => {
  //       if (res.data) {
  //         return res.data; // data配列を返す
  //       } else {
  //         throw new Error(res.data.message || 'エラーが起きた');
  //       }
  //     })
  //     .catch((err) => {
  //       let errorMessage = '';
  //       if (err.code === 'ERR_NETWORK') {
  //         errorMessage = 'ネットワークエラー: ' + err.message;
  //       } else if (err.response) {
  //         errorMessage = err.response.data.msg || 'エラーが発生しました';
  //         if (err.response.status === 401) {
  //           router.push('/login');
  //         }
  //       } else {
  //         errorMessage = err.message;
  //       }
  //       throw new Error(errorMessage);
  //     });
  // },
  getUniqueStatus: (authUserId, sessionKey, tableId) => {
    config.url = baseUrl + '/api/status/get';
    config.method = 'POST';
    config.data = { authUserId, sessionKey, tableId };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  addNewCard: (authUserId, sessionKey, tableId, propertyId, statusKey, cardTitle, staffName) => {
    config.url = baseUrl + '/api/card/add';
    config.method = 'POST';
    config.data = {
      authInfo: {
        authUserId: authUserId,
        sessionKey: sessionKey
      }, tableId, 
      propertyId, 
      statusKey, 
      cardTitle, 
      staffName
    };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  deleteCard: (authUserId, sessionKey, cardId, staffName) => {
    config.url = baseUrl + '/api/card/delete';
    config.method = 'POST';
    config.data = {
      authInfo: {
        authUserId: authUserId,
        sessionKey: sessionKey
      }, 
      cardId,
      staffName
    };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },

  deleteData: (valueId, propertyId, propertyName, dataValue, authUserId, sessionKey, staffName) => {
    config.url = `${baseUrl}/api/value/delete`;
    config.method = 'POST';
    config.data = {
      valueId,
      propertyId,
      propertyName,
      dataValue,
      authUserId,
      sessionKey,
      staffName
    };
    return axios.request(config)
      .then(res => res)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg;
            router.push('/login');
          } else {
            ErrMsg = err.response.data.msg;
          }
        } else {
          ErrMsg = err.message;
        }
        return ErrMsg;
      });
  },

  selectionDataEdit: (dataValue, selectionData, authUserId, sessionKey, staffName) => {
    config.url = `${baseUrl}/api/value/selectionDataEdit`;
    config.method = 'POST';
    config.data = {
      dataValue,
      selectionData,
      authInfo: {
      authUserId,
      sessionKey},
      staffName
    };

    return axios.request(config)
      .then(res => res)
      .catch(err => {
        let ErrMsg = '';
        let status = null;

        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          status = err.response.status;
          if (status === 401) {
            ErrMsg = err.response.data.message || err.response.data.msg || '認証エラー';
            router.push('/login');
          } else {
            ErrMsg = err.response.data.message || err.response.data.msg || 'エラーが発生しました';
          }
        } else {
          ErrMsg = err.message;
        }
        return Promise.reject({ status, message: ErrMsg });
      });
  },

  updateCardStatus: (authUserId, sessionKey, staffName, valueId, dataValue) => {
    config.url = `${baseUrl}/api/card/updateCardStatus`;
    config.method = 'POST';
    config.data = {
      authInfo: {
      authUserId,
      sessionKey},
      staffName,
      valueId,
      dataValue,
    };

    return axios.request(config)
      .then(res => res)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg;
            router.push('/login');
          } else {
            ErrMsg = err.response.data.msg;
          }
        } else {
          ErrMsg = err.message;
        }
        return ErrMsg;
      });
  }
};